export type SpeciesDisplay = {
  label: string;
  unassigned: boolean;
};

/** Anzeige in der Akte. Freitext bleibt sichtbar und ist nicht zugeordnet. */
export function formatCaseSpecies(row: {
  species_name?: string | null;
  species_free_text?: string | null;
}): SpeciesDisplay | null {
  const free = row.species_free_text?.trim() ?? "";
  if (free.length > 0) return { label: free, unassigned: true };
  const name = row.species_name?.trim() ?? "";
  if (name.length > 0) return { label: name, unassigned: false };
  return null;
}
